import { render, staticRenderFns } from "./SalesDetailTableAll.vue?vue&type=template&id=4ddc4bc0&"
import script from "./SalesDetailTableAll.vue?vue&type=script&lang=js&"
export * from "./SalesDetailTableAll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports